<template>
    <div class="d-flex flex-1 h-100 overflow-auto">
        <v-card class="report-container w-100  p-0" style="border-radius: 12px; margin-bottom: 24px">
            <v-toolbar class="shadow-none"  v-if="!fromOrganaize" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click=" backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_ManageUsers") }}</v-toolbar-title>
            </v-toolbar>

            <div class="border-top p-4 flex-1 overflow-auto">
                <div class="row align-items-start flex-nowrap m-0 gap-2" style="flex: unset">
                    <div class="col-md-4 p-0">
                        <v-label>{{ $t("res_Label_SearchforUser") }} </v-label>
                        <v-text-field v-model="search_query" @keyup.enter="searchUsers(true)"  label="" solo></v-text-field>
                    </div>
                    <!-- <div class="col-md-4 p-0">
                        <v-label>{{ $t("res_Label_SelectCompany") }} *</v-label>
                        <multi-select class="light-bg add-arrow" v-model="companyId" label="name" track-by="id"
                            open-direction="bottom" :options="company_items" :searchable="false" :loading="loading"
                            :internal-search="false" :clear-on-select="false" :close-on-select="true"
                            :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false"
                            :multiple="false" :placeholder="$t('res_Label_Select')">
                        </multi-select>
                    </div> -->
                    <div class="col-md-4 p-0 h-100">
                        <div class="d-flex gap-2 h-100 align-items-end">
                            <v-btn color="light-blue" dense @click="clearFields()">{{ $t("res_ButtonText_Clear") }}</v-btn>
                            <v-btn color="primary" dense @click="searchUsers(true)">{{ $t("res_ButtonText_Search") }}</v-btn>
                            <v-btn color="primary" @click="addUser()">{{ $t("res_ButtonText_AddUser") }}</v-btn>
                        </div>
                    </div> 
                </div>

                <hr>

                <div class="d-flex flex-1 flex-column overflow-auto">
                    <Pagination class="mb-2" :totalCount="pagingData.totalCount" :pageSize="pagingData.pageSize"
                        :pageIndex="pagingData.pageIndex" @pageIndexChanged="pageIndexChanged"></Pagination>
                    <v-data-table :mobile-breakpoint="0" class="position-relative white flex-1 d-flex overflow-auto" disable-sort
                        :headers="headers" :items="user_items" :loading="loading" loading-text="loading..."
                        :no-data-text="$t('res_Label_NoData')" :footer-props="{ 'items-per-page-text': 'Items per page' }" caption=""
                        hide-default-footer  header-fixed :class="{'no-data': user_items.length == 0}"  :items-per-page="pagingData.pageSize">
                        <template v-slot:no-data>
                            <div>
                                <img style="width: 118px" src="/assets/images/empty-inbox.svg" alt="" />
                                <p class="m-0">{{ $t("res_No_new_items_here") }}</p>
                            </div>
                        </template>

                        <template v-slot:item="row">
                            <tr>
                                <!-- <td>{{ row.item.id }}</td> -->
                                <td>{{ row.item.name }}</td>
                                <td>{{ row.item.nameAr }}</td>
                                <td>{{ row.item.email }}</td>
                                <td>
                                    <label v-tooltip.hover="row.item.parentNames.length > 50 ? row.item.parentNames : undefined">
                                        {{ row.item.parentNames | limitText(50) }}
                                    </label>
                                    
                                </td>
                                <td>{{ row.item.applicableRole }}</td>
                                <td class="text-start">
                                    <div class="onhover-display">
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-tooltip.hover="$t('res_Hover_ChangeUserAttributes')" @click="editUser(row.item.userId)">custom-icon white-bg edit-icon</v-icon>
                                        </div>
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-tooltip.hover="$t('res_Hover_ManageUserStructures')" @click="manageUserStructure(row.item.userId)">custom-icon white-bg gear-icon</v-icon>
                                        </div>
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-tooltip.hover="$t('res_Hover_SetUserPin')" @click="openChangePinCode(row.item.userId)">custom-icon white-bg code-icon</v-icon>
                                        </div>
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-tooltip.hover="$t('res_Hover_ManageUserSignatures')" @click="manageUserSignatures(row.item.userId)">custom-icon white-bg pen-icon</v-icon>
                                        </div>
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-tooltip.hover="$t('res_Hover_managerUserActions')" @click="managerUserActions(row.item.userId)">custom-icon white-bg edit-icon</v-icon>
                                        </div>
                                        
                                        <div class="custom-icon-wrapper">
                                            <v-icon 
                                            v-tooltip.hover="$t('res_Hover_ActiveOrDeActive')" 
                                            @click="changeUserActivationStatus(row.item.userId, row.item.active)"
                                            v-model="row.item.active"
                                            :class="{'green--text': row.item.active, 'red--text': !row.item.active}" >
                                            {{ row.item.active ? 'mdi-account-off' : 'mdi-account-check' }}
                                            </v-icon>                                       
                                        </div>
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-tooltip.hover="$t('res_Hover_ResetPasswordUser')" @click="openChangePassword(row.item.userId)">mdi-lock-reset</v-icon>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        
                    </v-data-table>
                </div>
            </div>
        </v-card>

        <v-dialog v-model="managerUserStructureDialog" :persistent="true" content-class="fullscreen-dialog" fullscreen>
            <div class="dialog-header">
                <v-toolbar class="bg-white">
                    <h1 class="mb-0">
                        {{$t("res_DialogTitle_ManageUser'sStructure")}}
                    </h1>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="managerUserStructureDialog=false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
            </div>
            <div class="dialog-body">
                <ManageStructures :userId="userId" :dialogModelShow="managerUserStructureDialog" v-on:closeDialog="managerUserStructureDialog = false">
                </ManageStructures>
            </div>
        </v-dialog>

        <v-dialog v-model="manageUserSignaturesDialog" content-class="fullscreen-dialog" fullscreen>
            <div class="dialog-header">
                <v-toolbar class="bg-white">
                    <h1 class="mb-0">
                        {{$t("res_Lable_ManageSignatures")}}
                    </h1>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="manageUserSignaturesDialog=false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
            </div>
            <div class="dialog-body">
                <UserSignatureManager :userid="userId" :dialogModelShow="manageUserSignaturesDialog"
                    v-on:closeDialog="manageUserSignaturesDialog = false"></UserSignatureManager>
            </div>
        </v-dialog>

    	<v-dialog v-model="changePinCodeDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen width="70%" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{$t("res_Lable_SetPinCode")}}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="changePinCodeDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">
                    <div class="p-4 flex-grow-1 overflow-auto">
                        <div class="mb-3-rem">
                            <v-label>{{$t("res_Label_NewPinCode")}}</v-label>
                            <v-text-field label="" solo v-model="userSecurity.newPinCode"></v-text-field>
                        </div>
                        <div class="mb-3-rem">
                            <v-label>{{$t("res_Label_ConfirmPinCode")}}</v-label>
                            <v-text-field label="" solo v-model="userSecurity.confirmPinCode"></v-text-field>
                        </div>
                    </div>
                    <v-card-actions class="top-shadow gap-3">
                        <v-btn class="light-blue flex-1"  @click="changePinCodeDialog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                        <v-btn class="primary flex-1"  @click="updatePinCode">{{$t("res_ButtonText_Save")}}</v-btn>
                    </v-card-actions>
                </div> 
            </v-card>
        </v-dialog>

        <v-dialog v-model="changeUserPasswordDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen width="70%" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{$t("res_Hover_ResetPasswordUser")}}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="changeUserPasswordDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">
                    <div class="p-4 flex-grow-1 overflow-auto">
                        <div class="mb-3-rem">
                            <v-label>{{$t("res_Label_NewPassword")}}</v-label>
                            <v-text-field label="" solo v-model="user.password"></v-text-field>
                        </div>
                        <div class="mb-3-rem">
                            <v-label>{{$t("res_Label_NewConfirmPassword")}}</v-label>
                            <v-text-field label="" solo v-model="user.confirmPassword"></v-text-field>
                        </div>
                    </div>
                    <v-card-actions class="top-shadow gap-3">
                        <v-btn class="light-blue flex-1"  @click="changeUserPasswordDialog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                        <v-btn class="primary flex-1"  @click="ResetPassword">{{$t("res_ButtonText_Save")}}</v-btn>
                    </v-card-actions>
                </div> 
            </v-card>
        </v-dialog>

    	<v-dialog v-model="manageApplicationRoleDialog" content-class="fullscreen-dialog" fullscreen>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{$t("res_DialogTitle_ManageApplicationRoles")}}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="manageApplicationRoleDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
               <ManageApplicationRoles :userId="userId" :dialogModelShow="manageApplicationRoleDialog"
                v-on:closeDialog="manageApplicationRoleDialog = false"></ManageApplicationRoles>
            </v-card>
        </v-dialog>

        <v-dialog v-model="managerUserActionsDialog" max-width="1000px" min-height="1000px">
			<v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">
                        <span>{{$t('res_Label_ManagePermissions')}}</span>
					</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="managerUserActionsDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">
                   <div class="grid-12 flex-1 p-4 overflow-auto gap-2">
						<ActionSecurityRole :roleId="0" :userId="userId" :search="Search" :seacrhvalue="SearchValue" :applicationId="applicationId" />
					</div>
				</div>
			</v-card>
		</v-dialog>

        <v-dialog v-model="upsertUserDialog" content-class="fullscreen-dialog" fullscreen>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title v-if="upsertUserDialogMode==='new'" class="p-0">{{ $t("res_DialogTitle_AddEditUser") }}</v-card-title>
                    <v-card-title v-if="upsertUserDialogMode==='edit'" class="p-0">{{ $t("res_DialogTitle_EditUser") }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="closeUpsertUserDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">   
                    <div class="grid-3 flex-1 p-4 overflow-auto gap-2">
                        <div id="ManageUsers_LoginProviderDiv">
                            <v-label>{{ $t("res_Label_LoginProvider") }} *</v-label>


                               <v-select v-model="user.loginProvider" :items="loginProviders" item-text="name" :menu-props="{ maxHeight: '1000px' }" item-value="id" label="" solo return-object class="custom-select">
                                <template v-slot:item="{ item }"> 
                                    <div class="custom-item">{{ item.name }}</div>
                                </template>
                                </v-select>

                            <!-- <v-select v-model="user.loginProvider" :items="loginProviders" item-text="name" item-value="id" label="" solo return-object class="custom-select"></v-select> -->
                        </div>
                        <div  v-if="user.loginProvider.id == '1' && upsertUserDialogMode == 'new'">
                            <v-label>{{ $t("res_Label_Password") }} *</v-label>
                            <v-text-field v-model="user.password" label="" solo type="password"></v-text-field>
                        </div>
                        <div  v-if="user.loginProvider.id == '1' && upsertUserDialogMode == 'new'">
                            <v-label>{{ $t("res_Label_ConfirmPassword") }} *</v-label>
                            <v-text-field v-model="user.confirmPassword" label="" solo type="password"></v-text-field>
                        </div> 
                        <div>
                            <v-label>{{ $t("res_GridHeaders_Salutation") }}</v-label>
                            <v-text-field v-model="user.salutation" label="" solo></v-text-field>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_FirstName") }} *</v-label>
                            <v-text-field v-model="user.firstName" label="" solo></v-text-field>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_MiddleName") }}</v-label>
                            <v-text-field v-model="user.middleName" label="" solo></v-text-field>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_LastName") }} *</v-label>
                            <v-text-field v-model="user.lastName" label="" solo></v-text-field>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_FirstNameAr") }} *</v-label>
                            <v-text-field v-model="user.firstNameAr" label="" @keydown="checkArabicEvent($event)" solo></v-text-field>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_MiddleNameAr") }}</v-label>
                            <v-text-field v-model="user.middleNameAr" label="" @keydown="checkArabicEvent($event)" solo></v-text-field>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_LastNameAr") }} *</v-label>
                            <v-text-field v-model="user.lastNameAr" label="" @keydown="checkArabicEvent($event)" solo></v-text-field>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_Username") }} *</v-label>
                            <v-text-field v-model="user.username" label="" solo></v-text-field>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_Email") }} *</v-label>
                            <v-text-field v-model="user.email" label="" solo></v-text-field>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_Gender") }} *</v-label>
                            <v-select v-model="user.gender" :items="genderTypes" item-text="name" item-value="id" label="" solo return-object></v-select>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_Title") }} *</v-label>
                            <v-text-field v-model="user.title" label="" solo></v-text-field>
                        </div>
                        <div >
                            <v-label>{{ $t("res_Label_Manager") }}</v-label>
                            <MultiSelect v-model="user.manager" class="light-bg add-arrow" label="name" track-by="id"
                                open-direction="bottom" :options="managers" :searchable="true" :loading="loading"
                                :internal-search="false" :clear-on-select="true" :close-on-select="true"
                                :options-limit="300" :max-height="600" :show-no-results="false" :placeholder="$t('res_Label_Select')"
                                :hide-selected="false" :multiple="false" @search-change="asyncFindManager"
                                @close="managers = []">
                                <template slot="option" slot-scope="props">
                                    <div >
                                        <div class="" style="">
                                            <v-avatar color="#eff2f5" size="40">{{
                                                CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                                        </div>
                                        <div class="ad__box" v-if="props.option.isUser">
                                            <p class="ad__text__bold">{{ props.option.name }}</p>
                                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}
                                            </p>
                                        </div>
                                        <div class="ad__box" v-else>
                                            <p class="ad__text__bold">{{ props.option.name }}</p>
                                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}
                                            </p>
                                        </div>
                                    </div>
                                </template>
                                <template slot="noOptions" slot-scope="props">
                                    {{ $t("res_Msgs_EmptySearch") }}
                                </template>
                            </MultiSelect>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_ApplicableRole") }} *</v-label>
                            <!-- <v-select v-model="user.applicationRole" :items="applicationRoles" item-text="name" item-value="id" label="" solo return-object></v-select> -->
                            <MultiSelect class="light-bg add-arrow" v-model="user.applicationRole" :placeholder="$t('res_Label_Select')"
                                label="name" track-by="id" open-direction="bottom" :options="applicationRoles"
                                :searchable="true" :loading="loading" :internal-search="false" dense
                                :clear-on-select="true" :close-on-select="true" :options-limit="300" 
                                :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false"
                                return-object>
                            </MultiSelect>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_TitleAr") }} *</v-label>
                            <v-text-field v-model="user.titleAr" @keydown="checkArabicEvent($event)" label="" solo></v-text-field>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_Profession") }} *</v-label>
                            <v-text-field v-model="user.profession" label="" solo></v-text-field>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_ProfessionAr") }} *</v-label>
                            <v-text-field v-model="user.professionAr" @keydown="checkArabicEvent($event)" label="" solo></v-text-field>
                        </div>
                        <div v-if="upsertUserDialogMode === 'new'">
                            <div>
                                <v-label>{{ $t("res_Label_Structure") }} *</v-label>
                                <StructureUserSelector :showInternalUsers="false" :showExternalUsers="false"
                                    :showInternalStructures="true"
                                    :showExternalStructures="true"
                                    :isMultiple="false" :selectedStructureUser="user.structure"
                                    :disabled="fromOrganaize"
                                    :disableOtherInternalEntitiesAsExternal="true"
                                    @structureUserSelectChanged="structureUserSelectChanged" :addressBook_header="$t('res_Label_SelectStrucutre')">
                                </StructureUserSelector>
                            </div>
                        </div>
                        <div v-if="upsertUserDialogMode === 'new'">
                            <v-label>{{ $t("res_Label_PrivacyLevel") }} *</v-label>
                            <v-select v-model="user.privacyLevel" :items="privacies" item-text="name" item-value="id" label="" solo return-object></v-select>
                        </div>
                        <div class="" v-if="upsertUserDialogMode === 'new'">
                            <!-- <v-label>{{ $t("res_Label_Role") }} *</v-label>
                            <v-select v-model="user.contactRole" :items="contactRoles" item-text="name" item-value="id" label="" solo return-object></v-select> -->
                        </div>
                        <div v-if="upsertUserDialogMode === 'new' && client_version_Id == 'ADNOC'">
                            <v-label class="mt-3 mb-0">{{ $t('res_CheckBox_HasSingleApprovalPermission') }}</v-label>
                            <v-checkbox class="mb-0 mt-0" v-model="user.hasSingleApprovalPermission" solo></v-checkbox>
                        </div>
                        <div v-if="upsertUserDialogMode === 'new'">
                            <v-label class="mt-3 mb-0">{{ $t('res_CheckBox_IsStructureReciever') }}</v-label>
                            <v-checkbox class="mb-0 mt-0" v-model="user.isStructureReceiver" solo></v-checkbox>
                        </div> 
                        <div v-if="upsertUserDialogMode === 'new'">
                            <v-label class="mt-3 mb-0">{{ $t('res_Label_IsDesignatedPerson') }}</v-label>
                            <v-checkbox class="mb-0 mt-0" v-model="user.isDesignatedPerson" solo></v-checkbox>
                        </div>
                        <div v-if="upsertUserDialogMode === 'new'">
                            <v-label class="mt-3 mb-0">{{ $t('res_Label_IsCanAddIncoming') }}</v-label>
                            <v-checkbox class="mb-0 mt-0" v-model="user.isCanAddIncoming" solo></v-checkbox>
                        </div>
                        <div>
                            <v-label class="mt-3 mb-0">{{ $t('res_CheckBox_Active') }}</v-label>
                            <v-checkbox class="mb-0 mt-0" v-model="user.active" solo></v-checkbox>
                        </div>
                    </div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn class="light-blue" style="min-width: 100px !important;" @click="closeUpsertUserDialog()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                        <v-btn class="primary" style="min-width: 100px !important;" @click="upsertUser()">{{ $t("res_ButtonText_Continue") }}</v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import router from '@/router/index.js'
import constants from '@/assets/js/constants'
import MultiSelect from 'vue-multiselect'
import ManageStructures from '@/components/ManageStructures.vue';
import ManageApplicationRoles from '@/components/ManageApplicationRoles.vue';
import Pagination from '@/components/Pagination.vue'
import * as utils from '@/assets/js/common.js'
import StructureUserSelector from '@/components/StructureUserSelector.vue'
import UserSignatureManager from '@/components/UserSignatureManager.vue'
import ActionSecurityRole from '@/components/ActionSecurityRole.vue'

export default {
    name: 'ManageUsers',
    components: { MultiSelect, ManageStructures, ManageApplicationRoles, Pagination, StructureUserSelector,UserSignatureManager,ActionSecurityRole  },
    data: function () {
        return {
            loading: false,
            search_query: '',
            companyId: null,
            user_items: [],
            company_items: [],
            userId: 0,
            manageApplicationRoleDialog: false,
            managerUserActionsDialog:false,
            options: ['list', 'of', 'options'],
            headers: [
                // { text: 'Id', value: 'id' },
                { text: this.$t("res_GridHeaders_Name"), value: 'name' ,width: '150px'},
                { text: this.$t("res_GridHeaders_NameAr"), value: 'nameAr',width: '150px' },
                { text: this.$t("res_GridHeaders_Email"), value: 'email',width: '150px' },
                { text: this.$t("res_GridHeaders_Structure"), value: 'parentName' ,width: '200px'},
                { text: this.$t("res_GridHeaders_ApplicableRole"), value: 'applicableRole' ,width: '200px'},
                { text: '', value: 'actions', sortable: false, width: '200px' },
            ],
            upsertUserDialogMode: 'new',
            upsertUserDialog: false,
            managerUserStructureDialog: false,
            changePinCodeDialog: false,
            changeUserPasswordDialog :false,
            showAddSignatureDialog: false,
            EditSignatureDialog:false,
            manageUserSignaturesDialog: false,
            loginProviders: [{ id: '1', name: 'Local' }, { id: '3', name: 'Microsoft' }],
            genderTypes: [{ id: 'M', name: 'Male' }, { id: 'F', name: 'Female' }],
            managers: [],
            structures: [],
            privacies: [],
            // contactRoles: [],
            applicationRoles: [],
            user:
            {
                loginProvider: { id: '1', name: 'Local' },
                password: '',
                confirmPassword: '',
                salutation: '',
                firstName: '',
                middleName: '',
                lastName: '',
                firstNameAr: '',
                middleNameAr: '',
                lastNameAr: '',
                username: '',
                email: '',
                gender: { id: 'M', name: 'Male' },
                active: true,
                manager: {},
                structure: {},
                title: '',
                titleAr: '',
                profession: '',
                professionAr: '',
                isExternalContact: false,
                hasSingleApprovalPermission: false,
                isStructureReceiver: false,
                privacyLevel: {},
                isDesignatedPerson: false,
                isCanAddIncoming: true,
                // contactRole: {},
                applicationRole: {}
            },
            userSecurity:
            {
                showCurrentPinCode: false,
                newPinCode: '',
                confirmPinCode: ''
            },
            signatureheaders: [
                { text: 'Id', value: 'id', sortable: false, align: ' d-none' },
                { text: this.$t("res_GridHeaders_Image"), value: 'thumbnail', sortable: false },
                { text: this.$t("res_GridHeaders_SignatureName"), value: 'name', sortable: false },
                { text: this.$t("res_GridHeaders_DefaultSignature"), value: 'isDefault', sortable: false },
                { text: '', value: '', sortable: false, width: '60px' },
            ],
            userSignature: {
                selectedSignatures: [],
                signatureName: '',
                signatureFile: {},
                isDefault: false,
                uploadDocument: [
                    value => !!value || 'Please upload signature'
                ],
            },
            pagingData: {
                pageSize: 10,
                pageIndex: 0,
                totalCount: 0
            },
            client_version_Id: constants.client_version_Id,
            applicationId: 1,
			Search:"",
			SearchValue:"",
        }
    },
    props: {
        structureId1: Number,
        fromOrganaize :{type : Boolean , default:false},
        structureProps :{type:Object ,default: {}}
    },
    methods: {
        getCompaniesForUser: function () {
            axios.get(constants.baseApiUrl + "Admin/GetCompaniesForUser")
                .then((res) => this.company_items = res.data)
                .catch((err) => console.warn(err))
        },
        getLoginProviders: function () {
            axios.get(constants.baseApiUrl + "Admin/ListLoginProviders")
                .then((res) => this.loginProviders = res.data)
                .catch((err) => console.warn(err))
        },
        checkArabicEvent(e)
        {  
            const englishCharRegex = /[a-zA-Z]/;
  
                if (e.ctrlKey || e.metaKey) {
                    return;
                }  
                let inputChar = e.key;  
                if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', 'Shift', 'CapsLock', 'Escape', 'Alt' , 'Unidentified'].includes(inputChar)) {
                    return;
                } 

                if (englishCharRegex.test(inputChar)) {
                    e.preventDefault();
                    window.showAlert(this.$t('res_Msgs_NotValidArabicName'), 'warning');
                }
 
                // if (e.key !== 'Backspace' && e.key !== 'Delete' && !arabicRegex.test(e.key)) 
                // {
                //     e.preventDefault();
                //     window.showAlert(this.$t('res_Msgs_NotValidArabicName'),'warning');
                // }
        },
        searchUsers: function (isResetPaging) {
            if (isResetPaging) {
                this.pagingData.totalCount = 0;
                this.pagingData.pageIndex = 0;
            }

            // if (this.companyId == null || this.companyId == undefined || this.companyId.id == undefined || this.companyId.id == null) {
            //     window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
            //     return
            // }
            var compId = this.fromOrganaize ? this.structureId1 : 0;
            window.showLoading()
            let params = `?query=${this.search_query}&companyId=${compId}&getCountOnly=false&pageIndex=${this.pagingData.pageIndex}&pageSize=${this.pagingData.pageSize}&structureId=${(this.structureId1 == undefined ? 0 : this.structureId1)}`; 
            axios.get(constants.baseApiUrl + "Admin/SearchUsersGrouped" + params)
                .then((res) => {
                    this.user_items = res.data  
                    let params_Count = `?query=${this.search_query}&companyId=${compId}&getCountOnly=true&structureId=${(this.structureId1 == undefined ? 0 : this.structureId1)}`;  
                    axios.get(constants.baseApiUrl + "Admin/SearchUsersGrouped" + params_Count)
                        .then((res) => {
                            this.pagingData.totalCount = res.data 
                        })
                        .catch((err) => console.warn(err))
                })
                .catch((err) => console.warn(err))
                .finally(() => window.hideLoading());
        },
        backToAdminPage(){
            router.push({ name: 'admin' })
        },
        clearFields() {
            this.search_query = ''
            this.companyId = {}
        },
        addUser() {
            this.upsertUserDialogMode = 'new';
            this.user.structure = this.structureProps;
            this.upsertUserDialog = true;
        },
        editUser(userId) {
            axios.get(constants.baseApiUrl + "Admin/GetUser?userId=" + userId)
                .then((res) => {
                    this.user = res.data
                    if(this.user.loginProvider != null){
                        this.user.loginProvider.id = parseInt(this.user.loginProvider.id);
                    }
                    this.upsertUserDialogMode = 'edit'
                    this.upsertUserDialog = true
                })
                .catch((err) => console.warn(err));
        },
        upsertUser() { 
             
            var isFormValid = true
            // if(!this.validateInput()){
            //     window.showAlert(this.$t('res_Msgs_NotValidArabicName'),'warning');
            //     return;
            // }

            if (this.user.firstName == '' || this.user.lastName == '' || this.user.firstNameAr == '' || this.user.lastNameAr == ''
                || this.user.firstName == null || this.user.lastName == null || this.user.firstNameAr == null || this.user.lastNameAr == null)
                isFormValid = false

            if (this.user.username == '' || this.user.email == '' || this.user.title == '' || this.user.titleAr == '' || this.user.profession == '' || this.user.professionAr == ''
                || this.user.username == null || this.user.email == null || this.user.title == null || this.user.titleAr == null || this.user.profession == null || this.user.professionAr == null)
                isFormValid = false

            if (this.upsertUserDialogMode == 'new') {
                if (this.user.structure.id == null || this.user.structure.id == undefined)
                    isFormValid = false

                if (this.user.privacyLevel.id == undefined || this.user.privacyLevel.id == null )
                    isFormValid = false
            }

            if (this.user.applicationRole == null || this.user.applicationRole == undefined || this.user.applicationRole.id == undefined || this.user.applicationRole.id == null)
                isFormValid = false

            if (isFormValid == false) {
                window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning')
                return
            }

            if (!this.validateEmail(this.user.email)) {
                window.showAlert(this.$t("res_Msgs_InvalidEmail"), 'warning')
                return
            } 
         
            if (this.upsertUserDialogMode == 'new' && this.user.loginProvider.id == '1') {
                if (this.user.password == '' || this.user.confirmPassword == '') {
                    window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning')
                    return
                }
                if (this.user.password != this.user.confirmPassword) {
                    window.showAlert(this.$t("res_Msgs_MatchPassword"), 'warning')
                    return
                }
                const password = this.user.password;
                const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!])(?=.{10,})/;

                if (!passwordRegex.test(password)) {
                    window.showAlert(this.$t("res_Msgs_PasswordRequirements"), 'warning');
                    return
                }
            }  

            //if (this.user.structure && this.user.structure.external != undefined && this.user.structure.external  != this.user.isExternalContact)
            //{
            //    if (this.user.structure.external)
            //        window.showAlert(this.$t("res_Msgs_ExternalStructureInternalUser"), 'warning');
            //    else
            //        window.showAlert(this.$t("res_Msgs_InternalStructureExternalUser"), 'warning'); 
                
            //    return
            //}
           
            axios.post(constants.baseApiUrl + "Admin/UpsertUser", this.user)
                .then((res) => {
                    if (res.data.item1 == true) {
                        window.showAlert(this.$t("res_Msgs_SuccessfullySaved"), 'success')
                        this.closeUpsertUserDialog()
                        this.searchUsers(true)
                    }
                    else {
                        if (res.data.item2 == 'UsernameAlreadyExists')
                            window.showAlert(this.$t("res_Msgs_AlreadyExists"), 'warning')
                        else
                            window.showAlert(res.data.item2, 'error')
                    }
                })
                .catch((err) => console.warn(err));
        },
        changeUserActivationStatus(_userId) 
        {
            window.showLoading()
            axios.get(constants.baseApiUrl + "Admin/ToggleUserActivationStatus?userId=" + _userId)
                .then((res) => {
                    if(res != null && res != undefined)
                    this.user_items.find(x=>x.userId == _userId).active =res.data
                })
                .catch((err) => console.warn(err))
                .finally(() => window.hideLoading());
        },
        manageUserStructure(userId) {
            this.userId = userId;
            this.managerUserStructureDialog = true;
        },
        openChangePinCode(userId) {
            this.userId = userId;
            this.changePinCodeDialog = true;
        },
        openChangePassword(userId) {
            this.userId = userId;
            this.changeUserPasswordDialog = true;
        },
        ResetPassword() {
            if (this.user.password == '' || this.user.confirmPassword == '') {
               window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning')
                return
            }
            if (this.user.password != this.user.confirmPassword) {
                window.showAlert(this.$t("res_Msgs_MatchPassword"), 'warning')
                return
            }
            const password = this.user.password;
            const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!])(?=.{10,})/;

            if (!passwordRegex.test(password)) {
                window.showAlert(this.$t("res_Msgs_PasswordRequirements"), 'warning');
                return
            }
            axios.post(constants.baseApiUrl + `Admin/ChangeUserPassword?userId=${this.userId}&newPassword=${this.user.password}`, null)
                .then((res) => {
                    if (res.data == true) {
                        window.showAlert(this.$t("res_Msgs_PasswordUpdateSuccess"), 'success')
                        this.user.password = ''
                        this.user.confirmPassword = ''
                        this.changeUserPasswordDialog = false
                    }
                    else {
                        window.showAlert(this.$t("res_Msgs_WrongPassword"), 'warning')
                    }
                })
                .catch((err) => console.warn(err));
        },
        updatePinCode() {
            if (this.userSecurity.newPinCode == '' || this.userSecurity.confirmPinCode == '') {
                window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning')
                return
            }

            if (this.userSecurity.newPinCode != this.userSecurity.confirmPinCode) {
                window.showAlert(this.$t("res_Msgs_MatchPassword"), 'warning')
                return
            }

            axios.post(constants.baseApiUrl + "Admin/ChangeUserPinCode?userId=" + this.userId + "&newPinCode=" + this.userSecurity.newPinCode, null)
                .then((res) => {
                    if (res.data == true) {
                        window.showAlert(this.$t("res_Msgs_PinUpdateSuccess"), 'success')
                        this.userSecurity.showCurrentPinCode = false 
                        this.userSecurity.newPinCode = ''
                        this.userSecurity.confirmPinCode = ''
                        this.changePinCodeDialog = false
                    }
                    else {
                        window.showAlert(this.$t("res_Msgs_WrongPin"), 'warning')
                    }
                })
                .catch((err) => { console.warn(err); window.showAlert(this.$t("res_Msgs_PinUpdateError"), 'error'); });
        },
        manageUserSignatures(userId) {
            this.userId = userId
           	
            this.manageUserSignaturesDialog = true
        },

        async readFile(file, successHandler) {
            var reader = new FileReader();
            var fileByteArray = [];
            reader.readAsArrayBuffer(file);
            reader.onloadend = function (evt) {
                if (evt.target.readyState == FileReader.DONE) {
                    var arrayBuffer = evt.target.result,
                        array = new Uint8Array(arrayBuffer);
                    for (var i = 0; i < array.length; i++) {
                        fileByteArray.push(array[i]);
                    }

                    successHandler(fileByteArray);
                }
            }
        },
        manageAppRole(fullUserId) {
            var userId = fullUserId.split('-')[0];
            this.userId = userId;
            this.manageApplicationRoleDialog = true;
        },
        managerUserActions(userId){ 
            //var userId = fullUserId.split('-')[0];
            this.userId = userId;
            this.managerUserActionsDialog = true;
        },
        closeUpsertUserDialog() {
            this.user = {
                loginProvider: { id: 1, name: 'Local' },
                password: '',
                confirmPassword: '',
                firstName: '',
                middleName: '',
                lastName: '',
                firstNameAr: '',
                salutation: '',
                middleNameAr: '',
                lastNameAr: '',
                username: '',
                email: '',
                gender: { id: 'M', name: 'Male' },
                active: true,
                manager: {},
                structure: {},
                title: '',
                titleAr: '',
                profession: '',
                professionAr: '',
                isExternalContact: false,
                hasSingleApprovalPermission: false,
                isStructureReceiver: false,
                privacyLevel: {},
                isDesignatedPerson: false,
                isCanAddIncoming: true,
               
                // contactRole: {}
            }
            this.upsertUserDialogMode = 'new'
            this.upsertUserDialog = false
        },
        asyncFindManager(query) {
            if (query == '') return;
            axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=false&showExternalStructures=false&search=' + query)
                .then(res => {
                    this.managers = res.data;
                    this.loading = false;
                })
                .catch(err => console.log(err));
        },
        CapitalizeFirstLetter(str) {
            return utils.CapitalizeFirstLetter(str);
        },
        GetMultiSelectSubHeaderDisplay(options) {
            return utils.GetMultiSelectSubHeaderDisplay(options)
        },
        validateEmail(email) {
            // Check if email contains only spaces
            if (email.trim() === "")
                return false;

            // Check if email contains '@' character
            if (!email.includes('@'))
                return false;

            // Check if email contains '@@'
            if (email.includes('@@'))
                return false;

            // Check if email contains spaces
            if (/\s/.test(email))
                return false;

            // Split email into local and domain parts
            const [localPart, domainPart] = email.split('@');

            // Check if local part is empty or starts/ends with a dot
            if (!localPart || localPart.startsWith('.') || localPart.endsWith('.'))
                return false;

            // Check if domain part is empty or starts/ends with a dot
            if (!domainPart || domainPart.startsWith('.') || domainPart.endsWith('.'))
                return false;

            // Check if domain part contains a dot (to ensure a top-level domain is present)
            if (!domainPart.includes('.'))
                return false;

            // Regular expression to check for a valid domain
            const domainRegex = /^(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)\.)*(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9]))\.([a-zA-Z]{2,})$/;

            // Regular expression to check for a valid IP address
            const ipRegex = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])$/;

            // Check if domain part is an invalid IP address
            if (domainRegex.test(domainPart) || ipRegex.test(domainPart))
                return true;
            else
                return false;

            return true;
        },
        pageIndexChanged(pagingData) {
            this.pagingData.pageSize = pagingData.pageSize;
            this.pagingData.pageIndex = pagingData.pageIndex;

            this.searchUsers(false);
        },
        structureUserSelectChanged(item) { 
            this.user.structure = item;
        }
    },
    filters: {
        limitText(text, maxSize){
            if (!text) return '';
            text = text.toString();

            if (text.length <= maxSize) {
                return text;
            }
            return text.substr(0, maxSize).trim() + ' ...';
        }
    },
    mounted: function () {
        // this.contactRoles = constants.contactRoles
        this.privacies = constants.privacies
        this.getCompaniesForUser()
        this.getLoginProviders()
        this.searchUsers()

        const intervalId = setInterval(() => {
            if (constants.isApplicaitonRolesLoaded == true) {
                clearInterval(intervalId);
                if (constants.isApplicaitonRolesLoaded == true)
                    this.applicationRoles = constants.applicationRoles
            }
        }, 100);

        if(this.fromOrganaize)
        {
            this.user.structure = this.structureProps
        }
    },
    watch: {
        structure_id(newVal, oldVal) 
        {
            if (newVal !== oldVal) {
                this.searchUsers()
            }
        }
    }
}
</script>
    

<style scoped>  
.container {
  width: "100%";
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}
.vtooltip {
    background-color: white;
    padding: 5px;
    border-radius: 25px;
}.report-container .v-input--selection-controls {
        margin-top: 0;
        padding-top: 0;
    }
    
    .report_header { 
        height: 50px;
        vertical-align: middle; 
        font-weight: 500;
        font-size: 12px;
        letter-spacing: 0.015em;
        color: #667593;
    }

    .report-container .theme--light.v-data-table.v-data-table--fixed-header thead th,  .report-container .v-data-table__wrapper table thead {
        background-color: #FFF;
        box-shadow: none;
    }

    .report-container {
        height: calc(100vh - 116px);
        display: flex;
        flex-direction: column;
        border-radius: 12px !important;
        overflow: auto;
        box-shadow: none !important;
    }

    .report-container .border-top {
        display: flex;
        flex-direction: column;
    }

    .report-container .v-toolbar {
        height: 80px !important;
        padding: 0;
    }
    .report-container .v-toolbar__content {
        height: 100% !important;
        padding: 24px !important;
    }img#ItemPreview {
    width: 100px;
    margin: 0.5rem 0;
}
.mdi-menu-down {
filter: brightness(0) saturate(100%) invert(39%) sepia(56%) saturate(232%) hue-rotate(182deg) brightness(102%) contrast(83%) !important ;
}.v-dialog .v-toolbar__content {
    height: 100% !IMPORTANT;
}
</style> 